import { z } from 'zod';

export const caseTypeCourtMappingSchema = z
  .object({
    caseTypeId: z.string({ message: 'Case Type is required' }).min(1, { message: 'Case Type is required' }),
    courtId: z.string().nullish(),
    courtType: z.string().nullish(),
  })
  .refine((values) => !!values.courtId || !!values.courtType, {
    message: 'Select a Court Name, a Court Type, or both',
    path: ['courtId'],
  });

export type CaseTypeCourtMappingFormValues = z.infer<typeof caseTypeCourtMappingSchema>;
